export default __webpack_public_path__ + "static/media/navbar-faq-dark.122c96c0.svg";